import Vue from 'vue';
import {
	// Affix,
	// Anchor,
	// AutoComplete,
	// Alert,
	// Avatar,
	// BackTop,
	// Badge,
	// Breadcrumb,
	Button,
	// Calendar,
	Card,
	// Collapse,
	// Carousel,
	// Cascader,
	Checkbox,
	Col,
	// DatePicker,
	Divider,
	Dropdown,
	Form,
	Icon,
	Input,
	// InputNumber,
	Layout,
	// List,
	// LocaleProvider,
	Menu,
	Modal,
	// Pagination,
	// Popconfirm,
	Popover,
	// Progress,
	Radio,
	// Rate,
	Row,
	Select,
	// Slider,
	// Spin,
	// Steps,
	Switch,
	// Table,
	// Transfer,
	// Tree,
	// TreeSelect,
	// Tabs,
	// Tag,
	// TimePicker,
	// Timeline,
	Tooltip,
	// Upload,
	Drawer,
	// Skeleton,
	// ConfigProvider,
	message
} from 'ant-design-vue';

const components = [
	// Affix,
	// Anchor,
	// AutoComplete,
	// Alert,
	// Avatar,
	// BackTop,
	// Badge,
	// Breadcrumb,
	Button,
	// Calendar,
	Card,
	// Collapse,
	// Carousel,
	// Cascader,
	Checkbox,
	Col,
	// DatePicker,
	Divider,
	Dropdown,
	Form,
	Icon,
	Input,
	// InputNumber,
	Layout,
	// List,
	// LocaleProvider,
	Menu,
	Modal,
	// Pagination,
	// Popconfirm,
	Popover,
	// Progress,
	Radio,
	// Rate,
	Row,
	Select,
	// Slider,
	// Spin,
	// Steps,
	Switch,
	// Table,
	// Transfer,
	// Tree,
	// TreeSelect,
	// Tabs,
	// Tag,
	// TimePicker,
	// Timeline,
	Tooltip,
	// Upload,
	Drawer,
	// Skeleton,
	// ConfigProvider
];

message.config({
	duration: 2
});

Vue.prototype.$message = message;
Vue.prototype.$confirm = Modal.confirm;

export default{
	install(Vue){
		components.map(item => {
			Vue.use(item);
		});
	}
};



// WEBPACK FOOTER //
// ./src/utils/antd-vue.js